/**
 * Defensively pulls the array out of a list-endpoint response body. Most of
 * this app's list endpoints return `{ Result: [...] }`, but not all of them
 * do — Chat/BlockedOrKickedUsers came back with a non-array `Result` and
 * crashed a `.map()` in production, live-caught after ParticipantsTab
 * shipped (see [[promoter-panel-porting-workflow]]). Tries every response
 * shape seen elsewhere in this codebase instead of assuming one.
 */
export const extractListResult = (data) => {
  const candidates = [data?.Result, data, data?.Result?.Data, data?.Result?.Items, data?.Data, data?.Items];
  return candidates.find(Array.isArray) || [];
};
